import { store } from 'store';
import { FILTERS } from 'constants/Filters';

export const isPrimaryFilterOpen = () => {
  const state = store.getState();

  return state.filters.currentFilter === FILTERS.PRIMARY && state.current_view.displayFilter;
};
